module.exports = __webpack_public_path__ + "assets/smd-alt.e25249f0.svg";